/**
 * Parse a GeoJSON boundary (as returned by getFarmPolygon field.boundry)
 * into an array of LatLngLiteral for Google Maps polygon rendering.
 */
export function parseBoundary(boundry: any): google.maps.LatLngLiteral[] {
  try {
    const data = typeof boundry === 'string' ? JSON.parse(boundry) : boundry;
    if (!data?.features?.[0]?.geometry?.coordinates) return [];
    const coordinates = data.features[0].geometry.coordinates;
    const paths: google.maps.LatLngLiteral[] = [];
    coordinates.forEach((coordinate: any) => {
      if (coordinate.length === 1) {
        coordinate[0].forEach((latLng: any) => {
          paths.push({ lat: Number(latLng[1]), lng: Number(latLng[0]) });
        });
      } else if (coordinate[0].length === 2) {
        coordinate.forEach((coord: any) => {
          paths.push({ lat: Number(coord[1]), lng: Number(coord[0]) });
        });
      } else {
        coordinate[0].forEach((latLng: any) => {
          paths.push({ lat: Number(latLng[1]), lng: Number(latLng[0]) });
        });
      }
    });
    return paths;
  } catch {
    return [];
  }
}

/**
 * Calculate LatLngBounds from an array of polygon paths.
 */
export function calculateBounds(paths: google.maps.LatLngLiteral[]): google.maps.LatLngBoundsLiteral {
  let north = -90, south = 90, east = -180, west = 180;
  for (const point of paths) {
    if (point.lat > north) north = point.lat;
    if (point.lat < south) south = point.lat;
    if (point.lng > east) east = point.lng;
    if (point.lng < west) west = point.lng;
  }
  return { north, south, east, west };
}
